import { render } from "./system-integration.vue?vue&type=template&id=4cc7da7e"
import script from "./system-integration.vue?vue&type=script&lang=js"
export * from "./system-integration.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__